<item-preview-wrapper 
    class="waf-profile-custom-preview"
    [config]="config"
    [isItem]="isItem"
>
    <item-preview-wrapper_custom-content
        class="waf-profile-custom-preview__custom-content-section"
        *ngIf="isWafProfileInEvaluationMode"
    >
        <avi-full-modal-preview-message
            id="waf-profile-preview-message"
            [header]="l10nKeys.wafProfileLabel | vtranslate"
            [statusText]="l10nKeys.evaluationModeStatusText | vtranslate"
            [statusIcon]="'shield'"
        ></avi-full-modal-preview-message>
    </item-preview-wrapper_custom-content>
</item-preview-wrapper>
